import React, { useCallback } from 'react';
import styled from 'styled-components';

const Label = styled.label`
    font-weight: 500;
`;

function Checkbox({ name, value, modContent, onChange }) {
    const { options } = modContent;

    const isChecked = useCallback(
        (inpVal) =>
            Array.isArray(value) ? value.includes(inpVal) : value === inpVal,
        [value]
    );

    const handleChange = useCallback(
        (event) => {
            const { checked, value: inpVal } = event.target;

            if (Array.isArray(value)) {
                const nextValue = [...value];
                if (checked) {
                    nextValue.push(inpVal);
                } else {
                    nextValue.splice(nextValue.indexOf(inpVal), 1);
                }
                onChange({ name, value: nextValue });
            } else {
                onChange({ name, value: checked ? inpVal : '' });
            }
        },
        [name, onChange, value]
    );

    return (
        <div>
            {options.map((item, indx) => (
                <Label key={indx}>
                    <input
                        type="checkbox"
                        value={item.value}
                        onChange={handleChange}
                        checked={isChecked(item.value)}
                    />{' '}
                    {item.label}
                </Label>
            ))}
        </div>
    );
}

export default Checkbox;
